import { render, staticRenderFns } from "./edit-user.vue?vue&type=template&id=4224a1b1&scoped=true"
import script from "./edit-user.vue?vue&type=script&lang=js"
export * from "./edit-user.vue?vue&type=script&lang=js"
import style0 from "./edit-user.vue?vue&type=style&index=0&id=4224a1b1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4224a1b1",
  null
  
)

export default component.exports